module.exports = __webpack_public_path__ + "img/emptyIcon.367b1950.png";